import {useTranslation} from 'react-i18next'
import {useChartTokens} from '@/components/ui/apex-chart'
import {NivelDonut} from '@/components/bateria/nivel-charts'
import {SectionCard} from '@/components/section-card'
import type {NivelResumen} from '@/hooks/bateria/use-bateria-informe'
import {NIVELES} from '@/lib/bateria'
import {coloresDeNivel} from '@/lib/bateria-charts'

/** La leyenda va como texto: el color solo nunca es una lectura accesible. */
function DonutCuestionario({nivel}: {nivel: NivelResumen}) {
  const {t} = useTranslation()
  const tokens = useChartTokens()
  const colores = coloresDeNivel(tokens)
  const presentes = NIVELES.filter((n) => (nivel.distribucion[n] ?? 0) > 0)

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center" data-testid={`informe-donut-${nivel.clave}`}>
      <div className="w-full max-w-[190px] shrink-0 sm:w-[190px]">
        <NivelDonut
          distribucion={nivel.distribucion}
          label={nivel.label}
          size="68%"
          chartTestId={`informe-donut-chart-${nivel.clave}`}
        />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-foreground">{nivel.label}</p>
        <ul className="mt-1.5 space-y-1">
          {presentes.map((n) => (
            <li key={n} className="flex items-center gap-1.5 text-xs text-muted-foreground">
              <span
                aria-hidden
                className="inline-block size-2.5 shrink-0 rounded-[2px]"
                style={{backgroundColor: colores[n]}}
              />
              <span>
                {t(`admin.bateria.nivel.${n}`)}: {nivel.distribucion[n] ?? 0}
              </span>
            </li>
          ))}
          {presentes.length === 0 && (
            <li className="text-xs text-muted-foreground">{t('admin.bateria.informe.reparto.sinDatos')}</li>
          )}
        </ul>
      </div>
    </div>
  )
}

/** Bloque 3 (§P7): una dona por cuestionario presente; un informe de una sola forma no los trae todos. */
export function RepartoNivelDonut({
  cuestionarios,
  totalGeneral,
}: {
  cuestionarios: NivelResumen[]
  totalGeneral: NivelResumen | null
}) {
  const {t} = useTranslation()
  const todos = totalGeneral ? [...cuestionarios, totalGeneral] : cuestionarios
  return (
    <SectionCard
      title={t('admin.bateria.informe.reparto.title')}
      subtitle={t('admin.bateria.informe.reparto.subtitle')}
      testId="informe-reparto-nivel">
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        {todos.map((nivel) => (
          <DonutCuestionario key={nivel.clave} nivel={nivel} />
        ))}
      </div>
    </SectionCard>
  )
}
